import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { Menu, ChevronDown, LogOut } from 'lucide-react';
import Sidebar from './Sidebar';
import '../../styles/dashboard.css';
import '../../styles/sidebar.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

export default function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);
  const locale = useAuthStore((state) => state.locale);
  const setLocale = useAuthStore((state) => state.setLocale);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileDropdown, setProfileDropdown] = useState(false);

  const { t } = useTranslation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleLocale = () => {
    const newLocale = locale === 'ar' ? 'en' : 'ar';
    setLocale(newLocale);
    i18n.changeLanguage(newLocale);
    document.documentElement.setAttribute('dir', newLocale === 'ar' ? 'rtl' : 'ltr');
  };

  return (
    <div className="dashboard-container" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Main Content Area */}
      <div className="dashboard-content">
        {/* Topbar */}
        <header className="topbar">
          <button
            className="sidebar-toggle-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            title="Toggle sidebar"
            aria-label="Toggle menu"
          >
            <Menu size={24} />
          </button>

          <div className="topbar-right">
            <button
              className={`lang-toggle-btn${locale === 'ar' ? ' active-ar' : ' active-en'}`}
              onClick={toggleLocale}
              title={t('Toggle language')}
            >
              <span className="lang-label">EN</span>
              <span className="lang-divider">/</span>
              <span className="lang-label">AR</span>
            </button>
            <div className="profile-dropdown">
              <button
                className="profile-btn"
                onClick={() => setProfileDropdown(!profileDropdown)}
                aria-label="Profile menu"
              >
                <div className="profile-avatar">
                  {user?.first_name?.charAt(0).toUpperCase()}
                </div>
                <span className="profile-name hidden sm:inline">{user?.first_name}</span>
                <ChevronDown size={20} />
              </button>

              {profileDropdown && (
                <div className="dropdown-menu">
                  <a href="/dashboard/profile" className="dropdown-item">
                    👤 {t('Profile Settings')}
                  </a>
                  <button className="dropdown-item danger" onClick={handleLogout}>
                    <LogOut size={18} /> {t('Sign Out')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="dashboard-main">
          {children}
        </main>
      </div>
    </div>
  );
}
